/* eslint-disable no-unused-vars */
import { lazy } from 'react'
import HomeLayout from 'Layouts/home'
import AuthLayout from 'Layouts/auth'
import SettingLayout from 'Layouts/setting'
import BlankLayout from 'Layouts/blank'
import DashBoard from '../Modules/dashboard'

const Contact = lazy(() => import('Modules/contact'))
const HomeScreen = lazy(() => import('Modules/home'))
const AccountList = lazy(() => import('Modules/account-list'))
const AcceptInviteEmail = lazy(() => import('Modules/account-list/accept-invite'))
const AcceptInviteEmailSuccess = lazy(() => import('Modules/account-list/success'))
const ChangeEmail = lazy(() => import('Modules/account-list/change-email/verified'))
const LoginScreen = lazy(() => import('Modules/auth/login'))
const LogoutScreen = lazy(() => import('Modules/auth/logout'))
const ResetPasswordScreen = lazy(() => import('Modules/auth/resetPassword/reset'))
const ResetPasswordSuccessScreen = lazy(() => import('Modules/auth/resetPassword/resetSuccess'))
const ForgotPasswordScreen = lazy(() => import('Modules/auth/resetPassword/forgot'))
const ForgotPasswordSendMailScreen = lazy(() => import('Modules/auth/resetPassword/forgotSendMail'))
const WeeklyScreen = lazy(() => import('Modules/userList/weekly'))
const HeadCountScreen = lazy(() => import('Modules/userList/headCount'))
const AccountInfoScreen = lazy(() => import('Modules/accountInfo'))
const FA2Screen = lazy(() => import('Modules/2fa'))
const FA2SResetScreen = lazy(() => import('Modules/2fa/reset'))
const FA2SChoiceScreen = lazy(() => import('Modules/2fa/choice'))
const FA2AuthenticatorScreen = lazy(() => import('Modules/2fa/authenticator'))
const FA2SuccessScreen = lazy(() => import('Modules/2fa/success'))
const ChangePlanScreen = lazy(() => import('Modules/changePlan'))
const ChangePlanPaymentScreen = lazy(() => import('Modules/changePlan/payment'))
const AcceptInvite = lazy(() => import('Modules/accept-invite'))
const AcceptInviteExternal = lazy(() => import('Modules/accept-invite_external'))
const UpdateTeamPlanScreen = lazy(() => import('Modules/changePlan/register'))
const ContactUpgradeScreen = lazy(() => import('Modules/changePlan/contact'))

const UserListScreen = lazy(() => import('Modules/userList'))
const DashBoardUserListScreen = lazy(() => import('Modules/userList/dashboard'))
const WeeklyUserListScreen = lazy(() => import('Modules/userList/weekly'))
const HeadCountUserListScreen = lazy(() => import('Modules/userList/headCount'))
const Payment = lazy(() => import('Modules/payment'))

export const RoutesName = {
  HOME: '/',
  DASHBOARD: '/dashboard',
  ACCOUNT_LIST: '/account',
  CONTACT: '/contact',
  DASHBOARDBYID: '/dashboard/:id',
  LOGIN: '/login',
  LOGOUT: '/logout',
  RESET_PASSWORD: '/admin/reset-password/:email/:code',
  RESET_SUCCESS: '/reset-success',
  FORGOT_PASSWORD: '/forgot',
  FORGOT_PASSWORD_SEND_MAIL: '/send-mail/:mail',
  WEEKLY: '/weekly',
  WEEKLY_ID: '/weekly/:id',
  HEAD_COUNT: '/head-count',
  HEAD_COUNT_ID: '/head-count/:id',
  ACCOUNT_INFO: '/account-info',
  SETTING_2FA: '/2fa',
  CHANGE_PLAN: '/change-plan',
  CHANGE_PLAN_PAYMENT: '/change-plan/payment',
  PAYMENT: '/payment',
  SAAS_TOOL: '/saas-tool',
  SETTING_2FA_RESET: '/2fa/reset',
  SETTING_2FA_CHOICE: '/2fa/choice',
  SUCCESS_2FA: '/2fa/success',
  AUTHENTICATOR_2FA: '/2fa/authenticator/:type',
  ACCEPT_INVITE: '/accept-invitation/second-login/:email/:portfolioId/:code',
  ACCEPT_INVITE_EXTERNAL_SYSTEM: '/accept-invitation/first-login/:email/:portfolioId/:code',
  CHANGE_PLAN_TEAM_PLAN: '/change-plan/:type',
  CHANGE_PLAN_CONTACT: '/change-plan/register/contact',

  USER_LIST: {
    GET: '/user-list',
    DASH_BOARD_USER_LIST: '/user/:idUser/portfolio/:idPortfolio/dashboard',
    WEEKLY_USER_LIST: '/user/:idUser/portfolio/:idPortfolio/weekly',
    HEADCOUNT_USER_LIST: '/user/:idUser/portfolio/:idPortfolio/head-count',
    ACCOUNT_INFO_ID: '/account-info/:idUser'
  },
  ACCEPT_INVITE_EMAIL: '/admin/accept-invitation/:email/:inviteCode',
  ACCEPT_INVITE_EMAIL_SUCCESS: '/admin/accept-invitation/success',
  VERIFY_CHANGE_EMAIL: '/change-email/confirm/:oldEmail/:code',
  NOT_FOUND: '/not-found'
}

export const ROUTES = [
  {
    path: RoutesName.HOME,
    isAuth: true,
    isCustom: true,
    component: HomeScreen,
    layout: BlankLayout,
    rules: []
  },
  {
    path: RoutesName.ACCOUNT_LIST,
    component: AccountList,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.DASHBOARD,
    isAuth: true,
    component: DashBoard,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.DASHBOARDBYID,
    isAuth: true,
    component: DashBoard,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.LOGIN,
    component: LoginScreen,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.RESET_PASSWORD,
    component: ResetPasswordScreen,
    isAuth: true,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.RESET_SUCCESS,
    component: ResetPasswordSuccessScreen,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.FORGOT_PASSWORD,
    component: ForgotPasswordScreen,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.FORGOT_PASSWORD_SEND_MAIL,
    component: ForgotPasswordSendMailScreen,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.ACCEPT_INVITE_EMAIL,
    component: AcceptInviteEmail,
    isAuth: true,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.ACCEPT_INVITE_EMAIL_SUCCESS,
    component: AcceptInviteEmailSuccess,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.VERIFY_CHANGE_EMAIL,
    component: ChangeEmail,
    isAuth: true,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.WEEKLY,
    component: WeeklyScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.WEEKLY_ID,
    component: WeeklyScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.HEAD_COUNT,
    component: HeadCountScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.HEAD_COUNT_ID,
    component: HeadCountScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.ACCOUNT_INFO,
    component: AccountInfoScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.USER_LIST.ACCOUNT_INFO_ID,
    component: AccountInfoScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.SETTING_2FA,
    component: FA2Screen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.CHANGE_PLAN,
    component: ChangePlanScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.SETTING_2FA_RESET,
    component: FA2SResetScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.SETTING_2FA_CHOICE,
    component: FA2SChoiceScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.AUTHENTICATOR_2FA,
    component: FA2AuthenticatorScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.SUCCESS_2FA,
    component: FA2SuccessScreen,
    isAuth: true,
    layout: SettingLayout,
    rules: []
  },
  {
    path: RoutesName.LOGOUT,
    component: LogoutScreen,
    isCustom: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.CHANGE_PLAN_PAYMENT,
    component: ChangePlanPaymentScreen,
    isAuth: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.CHANGE_PLAN_PAYMENT,
    component: ChangePlanPaymentScreen,
    isAuth: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.ACCEPT_INVITE,
    component: AcceptInvite,
    isAuth: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.ACCEPT_INVITE_EXTERNAL_SYSTEM,
    component: AcceptInviteExternal,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.CHANGE_PLAN_TEAM_PLAN,
    component: UpdateTeamPlanScreen,
    isAuth: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.CHANGE_PLAN_CONTACT,
    component: ContactUpgradeScreen,
    isAuth: true,
    layout: AuthLayout,
    rules: []
  },
  {
    path: RoutesName.USER_LIST.GET,
    component: UserListScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.PAYMENT,
    component: Payment,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.CONTACT,
    component: Contact,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.USER_LIST.WEEKLY_USER_LIST,
    component: WeeklyUserListScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.USER_LIST.HEADCOUNT_USER_LIST,
    component: HeadCountUserListScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.USER_LIST.DASH_BOARD_USER_LIST,
    component: DashBoardUserListScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  },
  {
    path: RoutesName.USER_USER_LIST,
    component: DashBoardUserListScreen,
    isAuth: true,
    layout: HomeLayout,
    rules: []
  }
]

export default RoutesName
